import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from '@/lang/config'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import { createLocalVue, shallowMount, ThisTypedShallowMountOptions, VueClass, Wrapper } from '@vue/test-utils'
import { store } from '@/store/store'
import { DateUtils } from '@/shared/util/date-utils'

export const vtMockId = () => Math.floor(Math.random() * 1000000)
export const vtMockDate = () => DateUtils.formatDate(new Date())!

export function vtCreateLocalVue(): typeof Vue {
    const localVue = createLocalVue()
    localVue.use(VueI18n)
    localVue.use(Vuex)
    localVue.use(VueRouter)
    return localVue
}

export function vtShallowMount<V extends Vue>(component: VueClass<V>, options?: ThisTypedShallowMountOptions<V>): Wrapper<V> {
    const localVue = vtCreateLocalVue()
    const i18n = new VueI18n(config)
    return shallowMount(component, {
        i18n,
        store,
        localVue,
        ...options
    })
}
